(function () {

    "use strict";

    angular
        .module("parLabor")
        .service("ParLaborDataService", ParLaborDataService);

    ParLaborDataService.$inject = ['$q', 'TeamScheduleService', 'generalSalesService'];

    function ParLaborDataService ($q, TeamScheduleService, generalSalesService) {
        var service = this;

        var getDayIndexMap = function (startDay) {
            var dayIndexMap = {};

            for (var i = 0; i < 7; i++) {
                var key = moment(startDay).add(i, 'days').format('ddd').toUpperCase();
                dayIndexMap[key] = i;
            }

            return dayIndexMap
        };

        var prepareNewParForecast = function (position, dayPartItem, dayIndex) {
            var positionParForecast = {};

            positionParForecast['position'] = position;

            if (dayPartItem.day_part) {
                positionParForecast['par_type'] = {value: 'PAR_DAY_PART', name: 'PAR Day Part'};
                positionParForecast['day_part'] = dayPartItem.day_part;
            } else {
                positionParForecast['par_type'] = {value: 'PAR', name: 'PAR'};
                positionParForecast['day_part'] = {name: 'PAR', id: null};
            }

            positionParForecast['totalShifts'] = 0;
            positionParForecast['days'] = [];
            positionParForecast['days'][dayIndex] = {'number_of_shifts': dayPartItem.number_of_shifts};

            return positionParForecast;
        };

        var prepareParForecastData = function (data) {
            var dayIndexMap = getDayIndexMap(data.week);
            var positionParForecast;

            var forecast = {
                food_sales_percentage: data.food_sales_percentage,
                id: data.id,
                week: data.week,
                weekSales: [],
                numberOfFilledPositions: 0,
                positionsParForecasts: []
            };

            for (var i in data.days) {
                var dayForecast = data.days[i];
                var dayIndex = dayIndexMap[dayForecast.day];

                forecast['weekSales'][dayIndex] = {
                    'total_sales': (dayForecast.total_sales / 100),
                    'date': moment(data.week).add(dayIndex, 'days').format('YYYY-MM-DD')
                };

                var positionParForecasts = dayForecast['position_par_forecasts'];
                forecast['numberOfFilledPositions'] = positionParForecasts.length;

                for (var j in positionParForecasts) {
                    var positionForecast = positionParForecasts[j];

                    if (forecast['positionsParForecasts'].length) {
                        if (positionForecast.day_parts.length === 1 && !positionForecast.day_parts[0].day_part) {
                            var isPositionExist = false;

                            for (var k in forecast['positionsParForecasts']) {
                                var positionItem = forecast['positionsParForecasts'][k];

                                if ((positionForecast.position.code === positionItem.position.code) && ((positionForecast.day_parts[0].day_part && positionForecast.day_parts[0].day_part.id) === positionItem.day_part.id)) {
                                    isPositionExist = true;
                                    positionItem['days'][dayIndex] = {'number_of_shifts': positionForecast.day_parts[0].number_of_shifts};
                                    break;
                                }
                            }

                            if (!isPositionExist) {
                                positionParForecast = prepareNewParForecast(positionForecast.position, positionForecast.day_parts[0], dayIndex);
                                forecast['positionsParForecasts'].push(positionParForecast);
                            }

                        } else {
                            for (var n in positionForecast.day_parts) {
                                var isPositionExist = false;

                                for (var k in forecast['positionsParForecasts']) {
                                    var positionItem = forecast['positionsParForecasts'][k];

                                    if ((positionForecast.position.code === positionItem.position.code) && (positionForecast.day_parts[n].day_part.id === positionItem.day_part.id)) {
                                        isPositionExist = true;
                                        positionItem['days'][dayIndex] = {'number_of_shifts': positionForecast.day_parts[n].number_of_shifts};
                                        break;
                                    }
                                }

                                if (!isPositionExist) {
                                    positionParForecast = prepareNewParForecast(positionForecast.position, positionForecast.day_parts[n], dayIndex);
                                    forecast['positionsParForecasts'].push(positionParForecast);
                                }
                            }
                        }

                    } else {
                        if (positionForecast.day_parts.length === 1 && !positionForecast.day_parts[0].day_part) {
                            positionParForecast = prepareNewParForecast(positionForecast.position, positionForecast.day_parts[0], dayIndex);
                            forecast['positionsParForecasts'].push(positionParForecast);

                        } else {
                            for (var l in positionForecast.day_parts) {
                                positionParForecast = prepareNewParForecast(positionForecast.position, positionForecast.day_parts[l], dayIndex);
                                forecast['positionsParForecasts'].push(positionParForecast);
                            }
                        }
                    }
                }

            }

            return forecast;
        };

        var getDayAbbreviation = function (index, startDayOfWeek) {
            return moment(startDayOfWeek).add(index, 'days').format('ddd').toUpperCase();
        };

        service.prepareSavedData = function (data, forecastId, startDayOfWeek, isTemplate, name) {
            var parForecast = {
                food_sales_percentage: parseFloat(data.food_sales_percentage),
                days: []
            };

            if (!forecastId) {
                parForecast['week']= startDayOfWeek;
            }

            if (isTemplate) {
                parForecast['type'] = 'TEMPLATE';
                parForecast['name'] = name;
            } else {
                parForecast['type'] = 'ORDINARY';
            }

            for (var i in data.positionsParForecasts) {
                var forecast =  data.positionsParForecasts[i];

                if (forecast.position) {
                    for (var j in forecast.days) {
                        var forecastDay = forecast.days[j];

                        if (parForecast.days[j]) {
                            //check if position for this day exist
                            var isPositionFound = false;

                            for (var k in parForecast.days[j]['position_par_forecasts']) {
                                var position = parForecast.days[j]['position_par_forecasts'][k].position;

                                if (position.code === forecast.position.code) {
                                    isPositionFound = true;
                                    parForecast.days[j]['position_par_forecasts'][k]['day_parts'].push({
                                        day_part: forecast.day_part.id ? forecast.day_part : null,
                                        number_of_shifts: parseInt(forecastDay.number_of_shifts)
                                    });
                                    break;
                                }
                            }

                            if (!isPositionFound) {
                                parForecast.days[j]['position_par_forecasts'].push({
                                    position: forecast.position,
                                    day_parts: [
                                        {
                                            day_part: forecast.day_part.id ? forecast.day_part : null,
                                            number_of_shifts: parseInt(forecastDay.number_of_shifts)
                                        }
                                    ]
                                });
                            }

                        } else {
                            parForecast.days[j] = {'position_par_forecasts': []};
                            parForecast.days[j]['day'] = getDayAbbreviation(j, startDayOfWeek);
                            parForecast.days[j]['total_sales'] = parseInt(data.weekSales[j].total_sales * 100);
                            parForecast.days[j]['position_par_forecasts'][0] = {
                                position: forecast.position,
                                day_parts: [
                                    {
                                        day_part: forecast.day_part.id ? forecast.day_part : null,
                                        number_of_shifts: parseInt(forecastDay.number_of_shifts)
                                    }
                                ]
                            };
                        }
                    }
                }
            }

            return parForecast;
        };

        service.getBrandUserPositions = function () {
            var defer = $q.defer();
            var includePosition = true;

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    TeamAPI
                        .getBrandActivePositionCategories(brand.id, includePosition)
                        .then(function (res) {
                            defer.resolve(res);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.getBrandSales = function (startDate) {
            var defer = $q.defer();

            var params = {
                start_week_date: moment(startDate).format('YYYY-MM-DD')
            };

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    var businessDay = TeamScheduleService.getBusinessDay(startDate, brand.id);
                    generalSalesService
                        .getForecastedStatsGroupedByRC(brand.id, params, businessDay)
                        .then(function (res) {
                            defer.resolve(res);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.getParLaborForecasts = function (startDate, endDate) {
            var defer = $q.defer();
            var mode = 'BASIC';

            startDate = moment(startDate).format("YYYY-MM-DD");
            endDate = moment(endDate).format("YYYY-MM-DD");

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    ParLaborAPI
                        .getParLaborForecasts(brand.id, mode, startDate, endDate)
                        .then(function (res) {
                            defer.resolve(res);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.getWeekParForecast = function (forecastId, startOfWeek) {
            var defer = $q.defer();

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    ParLaborAPI
                        .getWeekParForecast(brand.id, forecastId)
                        .then(function (res) {
                            res['par_forecast']['week'] = res['par_forecast']['week'] || startOfWeek;
                            var parForecast = prepareParForecastData(res['par_forecast']);

                            defer.resolve(parForecast);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.deleteParForecast = function (forecastId) {
            var defer = $q.defer();

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    ParLaborAPI
                        .deleteParForecast(brand.id, forecastId)
                        .then(function (res) {
                            defer.resolve(res);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.createParForecast = function (parForecast) {
            var defer = $q.defer();

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    ParLaborAPI
                        .createParForecast(brand.id, {'par_forecast': parForecast})
                        .then(function (res) {
                            defer.resolve(res);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.updateParForecast = function (forecastId, parForecast) {
            var defer = $q.defer();

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    ParLaborAPI
                        .updateParForecast(brand.id, forecastId, {'par_forecast': parForecast})
                        .then(function (res) {
                            defer.resolve(res);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        service.getParForecastsTemplates = function () {
            var defer = $q.defer();

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    ParLaborAPI
                        .getParForecastsTemplates(brand.id)
                        .then(function (templates) {
                            defer.resolve(templates['par_forecasts']);

                        }, function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        return service;
    }
})();